<template>
	<div class="imofalform2FormHeader puiformheader"></div>
</template>

<script>
import PuiFormHeaderMixin from '@Pui9Mixins/PuiFormHeaderMixin';

export default {
	name: 'imofalform2-form-header',
	mixins: [PuiFormHeaderMixin],
	data() {
		return {
			modelName: 'imofalform2'
		};
	},
	computed: {}
};
</script>
